import * as Yup from 'yup';
import { ChannelsInfoWeb } from '../../../../../../shared/types/modules/channels-web-information';

export const initialValues: ChannelsInfoWeb = {
    document: '',
    typeDocument: '',
    name: '',
    cellPhone: '',
};

export const validationSchema = (juridicalId?: string) =>
    Yup.object({
        document: Yup.string()
            .required('La identificación es obligatoria')
            .max(
                20,
                'La identificación debe tener 20 caracteres alfanuméricos como máximo'
            )
            .matches(
                /^[a-zA-Z0-9]*$/,
                'La identificación solo debe contener caracteres alfanuméricos'
            ),
        typeDocument: Yup.string().required(
            'El tipo de documento es obligatorio'
        ),
        name: Yup.string().when('personType', {
            is: juridicalId,
            then: () =>
                Yup.string()
                    .required('El campo nombre y apellidos es obligatorio')
                    .max(
                        50,
                        'El campo nombre y apellidos debe tener 50 caracteres alfanuméricos como máximo'
                    )
                    .matches(
                        /^[a-zA-Z\s]*$/,
                        'El campo nombre y apellidos solo debe contener caracteres alfabéticos'
                    ),
            otherwise: () =>
                Yup.string()
                    .required('El campo nombres es obligatorio')
                    .max(
                        25,
                        'El campo nombres debe tener 25 caracteres alfanuméricos como máximo'
                    )
                    .matches(
                        /^[a-zA-Z\s]*$/,
                        'El campo nombres solo debe contener caracteres alfabéticos'
                    ),
        }),

        cellPhone: Yup.string()
            .required('El celular es obligatorio')
            .max(
                150,
                'El celular debe tener 150 caracteres alfanuméricos como máximo'
            )
            .matches(
                /^[a-zA-Z0-9]*$/,
                'El celular solo debe contener caracteres alfanuméricos'
            ),
    });
